// extracted by mini-css-extract-plugin
module.exports = {"componentsMapCard2":"styles_componentsMapCard2__OYPsU","merchantName":"styles_merchantName__3Pqkn","fixToBottom":"styles_fixToBottom__2g4Rp"};